import article from "./article";
import variationGroup from "./variationGroup";
import catalogNode from "./catalogNode";

function defaultState() {
  return {};
}

export default {
  namespaced: true,
  state: {
    ...defaultState()
  },
  modules: {
    article,
    variationGroup,
    catalogNode
  }
};
